<template>
    <b-card
        class="project-card"
        no-body
        :class="dashboardCard.type === 'magazine' && 'type-magazine'"
        @click="showCardDetail(dashboardCard)">
        <div
            class="management-tools"
            v-if="
                ((dashboardCard.type_id === 2 || dashboardCard.type_id === 6) && $authUser.isAdmin()) ||
                ((dashboardCard.type_id === 2 || dashboardCard.type_id === 6) && dashboardCard.is_group_admin && $authUser.isTeacher())
            ">
            <b-button
                class="btn-assignment-grade"
                variant="primary-icon"
                @click.prevent.stop="showGradeModal">
                <i class="fas fa-clipboard-check icon"></i>
            </b-button>
            <b-button
                class="btn-manage-portfolio btn-fad-settings"
                v-if="dashboardCard.type === 'group'"
                variant="primary-icon"
                @click.prevent.stop="getPortfolios(card.group_id)">
            </b-button>
        </div>

        <div
            class="magazine-cover"
            v-if="dashboardCard.type === 'magazine'"
            :class="dashboardCard.thumbnail === null && 'btn-missing-image no-preview'"
            :style="heightStyleObject"
            :ref="dashboardCard.type === 'magazine' && `magazinecover-${dashboardCard.id}`">
            <img
                class="magazine-cover-thumb"
                v-if="dashboardCard.thumbnail !== null"
                :src="dashboardCard.thumbnail" />
        </div>

        <b-card-img
            class="dashboard-card-banner"
            v-else
            :src="projectThumbnail()"
            top
            :style="cssVars"></b-card-img>

        <b-card-body body-class="dashboard-card-body">
            <b-card-title title-tag="h5">{{ dashboardCard.title }}</b-card-title>
            <div
                class="course-info"
                v-if="dashboardCard.type !== 'magazine'">
                {{ dashboardCard.course }} {{ dashboardCard.season ? ` | ${dashboardCard.season}` : '' }}
            </div>
            <b-progress
                class="project-progress-status"
                v-if="dashboardCard.roadmap"
                :max="dashboardCard.roadmap.steps.length"
                show-value>
                <b-progress-bar
                    v-for="(step, index) in steps"
                    v-b-tooltip.hover
                    :variant="getVariant(step)"
                    :value="step.value"
                    :key="index"
                    :title="toolTipLabel(step)">
                </b-progress-bar>
            </b-progress>

            <div
                class="users"
                v-if="dashboardCard.type === 'project' && $authUser.isTeacher()">
                {{ displayUsers(dashboardCard.users) }}
            </div>
        </b-card-body>
    </b-card>
</template>

<script>
    export default {
    name: 'design-2021-dashboard-card-component',
        props: {
            card: Object,
        },
        data() {
            return {
                dashboardCard: this.card,
                heightStyleObject: {},
        };
        },
        watch: {
            card: function (value) {
                this.dashboardCard = value;
        },
        },
        methods: {
            toolTipLabel(step) {
                switch (step.key) {
                    case 'done':
                    return this.$t('project.approved', { count: step.value });
                    case 'submitted':
                    return this.$t('project.submitted', { count: step.value });
                    case 'open':
                    return this.$t('project.open', { count: step.value });
                    case 'declined':
                    return this.$t('project.rejected', { count: step.value });
                }
            },

            getVariant(step) {
                switch (step.key) {
                    case 'done':
                        return 'success';
                    case 'submitted':
                        return 'warning';
                    case 'open':
                        return 'open';
                    case 'declined':
                        return 'danger';
                }
            },

            openMessageModal(id) {
                this.$refs['project-message-modal'].show(id);
                if (this.dashboardCard.type === 'project') {
                    this.$emit('reduce-unread-messages', {
                        group_id: this.dashboardCard.group_id,
                    value: this.dashboardCard.unread_messages_count,
                });
                }
                this.dashboardCard.unread_messages_count = 0;
            },

            showCardDetail(project) {
                if (project.type === 'magazine') {
                    location.href = `${project.type}/${project.id}`;
                } else if (project.type === 'groupPair') {
                    location.href = this.routes.groupPairStatus(project.id);
                } else if (project.type === 'project' && project.controller === 'magazine') {
                    location.href = `paper/${project.id}`;
            } else if ((project.type === 'project' && this.$authUser.isTeacher()) || this.$authUser.isStudent()) {
                location.href = `${project.controller}/${project.id}`;
            } else if (project.type_id === 3 && !this.$authUser.isStudent()) {
                location.href = `${this.routes.questRapport(project.id)}`;
            } else if (!this.$authUser.isStudent()) {
                location.href = `${this.routes.group()}/${project.id}`;
            } else {
                location.href = `${project.type}/${project.id}`;
            }
        },

        questSettings(id) {
            window.location.href = this.routes.questEdit(id);
        },

            questReport(id) {
                window.location.href = this.routes.questRapport(id);
            },

            questGroupReport(id) {
                window.location.href = `${this.routes.quest()}/group/rapport/${id}`;
            },

            displayUsers(users) {
                let userList = [];
                for (const user of users) {
                    if (user.type === 'student') {
                        userList.push(user.full_name);
                    }
                }

                return userList.join(', ');
            },
            projectThumbnail() {
                if (this.dashboardCard.banner) {
                    if (this.dashboardCard.banner.file.image) {
                    return this.dashboardCard.banner.file.image.thumb_path;
                    }
                    return this.dashboardCard.banner.file.public_path;
                }

                return this.dashboardCard.thumbnail;
            },

            onResize() {
                this.calculateHeight();
            },

            calculateHeight() {
                const name = `magazinecover-${this.dashboardCard.id}`;
                if (this.dashboardCard && this.dashboardCard.type === 'magazine' && this.dashboardCard.size) {
                const height = Math.ceil(
                    this.$refs[name].offsetWidth * (this.dashboardCard.size.height / this.dashboardCard.size.width),
                );
                    if (height + 'px' !== this.heightStyleObject.height) {
                        this.heightStyleObject = {
                        height: height + 'px',
                    };
                    }
                }
            },

            showGradeModal() {
                this.$emit('show-grade-modal', this.card.group_id);
            },

            getPortfolios(groupId) {
                window.location.href = this.routes.getPortfolioByGroupId(groupId);
        },
        },
        computed: {
            cssVars() {
                if (this.card.type === 'magazine') {
                    return {
                    '--ratio-value': `${this.card.size.width} / ${this.card.size.height}`,
                };
                }
            },

            steps() {
                //roadmap steps
                let declined = 0;
                let done = 0;
                let submitted = 0;
                let open = 0;
                let missing_open = 0;

                if (this.dashboardCard.roadmap !== undefined && this.dashboardCard.roadmap.steps !== undefined) {
                    for (const step of this.dashboardCard.roadmap.steps) {
                        if (step.finished !== undefined && step.status !== undefined) {
                            if (step.status === 2 && step.finished === 0) {
                                //status 2 && finished 0 = open na heropening (rood)

                                declined++;
                            } else if (step.status === 1 && step.finished === 1) {
                                //status 1 en fisnihed 1 = goed gekeurd.

                                done++;
                            } else if (step.status === 0 && step.finished === 1) {
                                //status 0 en finished 1 = ingeleverd

                                submitted++;
                            } else {
                                //status 0 && finished 0 = open nog nooit ingeleverd.
                            open++;
                            }
                        } else {
                            //geen status
                            missing_open++;
                        }
                    }
                }

                open += missing_open;

                return {
                    0: {
                        key: 'done',
                    value: done,
                    },
                    1: {
                        key: 'declined',
                    value: declined,
                    },
                    2: {
                        key: 'submitted',
                    value: submitted,
                    },
                    3: {
                        key: 'open',
                    value: open,
                },
            };
        },
        },

        mounted() {
            window.addEventListener('resize', this.onResize);
            this.calculateHeight();
        },

        beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
        },

        updated() {
            this.calculateHeight();
    },
};
</script>

<style scoped lang="scss">
    .project-card {
        height: 100%;
        cursor: pointer;
        border-radius: $border-radius-content;
        border: 1px solid $secondary-background-color;
    transition: all 0.3s ease;

        .btn-assignment-grade,
        .btn-manage-portfolio {
            position: absolute;
            top: 8px;
            width: 33.5px;
            height: 30px;
            box-shadow: 1px 1px 4px 0 rgba($black, 0.5);
            z-index: 10;

            &:hover {
                background-color: $white;
                color: $primary;
            }
        }

        .btn-manage-portfolio {
            right: 50px;

            &:before {
                margin-right: 0;
            }
        }

        .btn-assignment-grade {
            right: 8px;
            display: flex;
            align-items: center;
            justify-content: center;

            .icon {
                position: relative;
                font-size: 1.125rem;
                top: -1px;
            }

            &:hover {
                .pen-icon {
                    &:before {
                        color: $primary;
                    }

                    &:after {
                        color: var(--primaryLight);
                    }
                }
            }
        }

        &:hover {
            border-bottom-left-radius: $border-radius-content;
            border-bottom-right-radius: $border-radius-content;
        box-shadow:
            0 3px 21px 0 rgb(0 0 0 / 10%),
            0 1px 8px 0 rgb(0 0 0 / 5%);

            .dashboard-card-body {
                background-color: $custom-card-hover-color;
                border-bottom-left-radius: $border-radius-content;
                border-bottom-right-radius: $border-radius-content;
            }
        }

        .dashboard-card-banner {
            height: 100px;
            object-position: center;
            object-fit: cover;
            border-top-left-radius: $border-radius-content;
            border-top-right-radius: $border-radius-content;

            &:hover {
                border-bottom-left-radius: 0;
                border-bottom-right-radius: 0;
            }
        }

        .dashboard-card-body {
            padding: map-get($grid-gutter-spacing, 'fixteen') map-get($grid-gutter-spacing, 'twenty-one');

            .project-progress-status {
                margin-top: map-get($grid-gutter-spacing, 'ten');
            }

            .users {
                margin-top: map-get($grid-gutter-spacing, 'twenty-one');
                color: $text-muted-color;
                letter-spacing: 0.3px;
                line-height: 1.3;
                padding-top: map-get($grid-gutter-spacing, 'ten');
                border-top: 3px dotted $border-color;
                font-size: 0.8125rem;
            }
        }

        .card-title {
            margin-bottom: 0;
            line-height: 1;
            font-family: $headings-font-family;
            text-align: left;
        }

        .course-info {
            margin-top: map-get($grid-gutter-spacing, 'five');
            color: $text-muted-color;
            font-size: $default-font-size;
            line-height: 1;
        }

        &.type-magazine {
            .magazine-cover {
                border-top-right-radius: $border-radius-content;
                border-top-left-radius: $border-radius-content;
                height: 100%;

                img {
                    max-width: 100%;
                    height: inherit;
                    object-position: center;
                    object-fit: cover;
                    border-top-right-radius: $border-radius-content;
                    border-top-left-radius: $border-radius-content;
                }

                &.no-preview {
                    background-color: $inverse-info;
                    border-top-right-radius: $border-radius-content;
                    border-top-left-radius: $border-radius-content;
                    color: $white;
                    height: 100%;

                    &:before {
                        color: $white;
                        opacity: 0.3;
                        font-size: 9rem;
                        margin-right: 0;
                    }
                }

                &:hover {
                    cursor: pointer;
                }
            }
        }
    }
</style>
